import { memo, useEffect } from 'react';

import {
  getCommonAmplitudeProperties,
  getSourceEventParams,
  useAmplitude,
} from '@crehana/analytics';
import { PlayroomAchievementsSection } from '@crehana/compass.playroom';
// biome-ignore lint/style/noRestrictedImports: legacy import kept for compatibility
import { Container } from '@crehana/ui';

import {
  PageLayoutBreadcrumb,
  PageLayoutTop,
} from '@/shared/vendor/compass-web-page-layout';
import { useLearnDashboardContext } from '@/views/LearnDashboard/context';
import useLearnBreadcrumbTrail from '@/views/LearnDashboard/hooks/useLearnBreadcrumbTrail';

const PlayroomAchievementSection = () => {
  const { items, isLoading } = useLearnBreadcrumbTrail();
  const {
    organizationSlug,
    isPlayroomEnabled,
    isLoadingPlayroomActivated,
    me,
  } = useLearnDashboardContext();
  const { logEvent } = useAmplitude();

  const organizationId = me.organization?.originalId?.toString() as string;

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentionally managed
  useEffect(() => {
    if (!isLoadingPlayroomActivated) {
      logEvent({
        event: 'Render Home Achievements',
        data: {
          ...getSourceEventParams(),
          ...getCommonAmplitudeProperties(me, isPlayroomEnabled),
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadingPlayroomActivated, isPlayroomEnabled]);

  return (
    <>
      <PageLayoutTop className="tw-pb-0" transparent>
        <PageLayoutBreadcrumb items={items} isLoading={isLoading} />
      </PageLayoutTop>

      <Container type="dashboard" className="tw-mt-2">
        <PlayroomAchievementsSection
          organizationId={organizationId}
          organizationSlug={organizationSlug as string}
        />{' '}
        {/* TODO: Remove organizationSlug if necessary */}
      </Container>
    </>
  );
};

export default memo(PlayroomAchievementSection);
